import { TipoOrigemEnum } from '@/types/_'
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

export class ConfigSuporte extends CoreBase implements IConfigSuporte {
}

export interface IConfigSuporte extends ICoreBase {
}
